import '@/scss/pages/math-single.scss'

import { adjustAnchorScroll } from '@/js/helpers/scroll'
import header from '@/js/layout/header'
import sliderMathPdf from '@/js/section/math/shortcode-pdf'
import singleCTA from '@/js/section/blog/single-cta'
import fullForm from '@/js/section/home/full-form'
import { getTableOfContents } from '@/js/common/table-of-contents'
import { initContentTabs, initTabLinks } from '@/js/common/content-tabs'
import initEmailPopup from '@/js/section/email-popup'
import videoResponsive from '@/js/common/video-responsive'
import anchor from '@/js/common/anchor'
import initStrip from '@/js/section/blog/strip'
import { bannerCta, bannerWide } from '../common/banners'
import manageClassName from '@/js/helpers/manage-class'
import {
  setTrackExitPopupCloseEvent,
  setTrackStripCloseEvent
} from '@/js/common/button-track'
import { initClarity } from '@/js/helpers/clarity'
import config from '@/js/common/config.json'

document.addEventListener('DOMContentLoaded', async () => {
  header()
  sliderMathPdf()
  singleCTA()
  fullForm()
  getTableOfContents()
  initContentTabs()
  initEmailPopup()
  videoResponsive()
  anchor()
  initStrip()
  setTrackStripCloseEvent()
  setTrackExitPopupCloseEvent()
  bannerWide()
  bannerCta()
  manageClassName('iframe', 'iframe-formatting', 'add')
  initClarity('#main', config.math)
  adjustAnchorScroll()
  await initTabLinks()
})
